import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import EmailSignupForm from '../brand/EmailSignupForm';
import { media } from '../../styles/style-utils';
import { type } from '../../styles/typography';

const Poster = styled.section`
  ${type('poster', 'xlarge', { emphasis: true, uppercase: true })};
  display: flex;
  flex-direction: column;
  gap: 37px;
  padding: 72px var(--b-gutter) 20px;
  overflow: hidden;
  background-color: var(--b-black);
  color: var(--b-white);
  height: 300px;

  > div {
    display: flex;
    justify-content: space-between;
  }

  @supports (background-clip: text) {
    span {
      background-image:
        linear-gradient(var(--b-pink), var(--b-pink)),
        linear-gradient(var(--b-white), var(--b-white));
      background-size:
        calc((100% - var(--fill-start, 0%)) * 0.8) 0%,
        100% 100%;
      background-position:
        100% 100%,
        0 0;
      background-repeat: no-repeat;
      background-clip: text;
      color: transparent;
      transition: background-size 0.7s cubic-bezier(0.34, 1.4, 0.64, 1);
    }

    @media (hover: hover) {
      &:hover span {
        background-size:
          calc(100% - var(--fill-start, 0%)) 53%,
          100% 100%;
      }
    }
  }

  ${media.medium`
    height: 400px;
  `}

  ${media.large`
    height: 537px;
  `}
`;

const Newsletter = styled.section`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 28px var(--b-gutter);
  background-color: var(--b-pink);
  color: var(--b-black);

  ${media.extraLarge`
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: 40px;
  `};

  h2 {
    ${type('headline', 'large')};
    flex: 1 1 0;
    margin: 0;
    padding: 0;
    color: var(--b-black);

    ${media.extraLarge`
      flex: 0 1 auto;
    `};
  }

  > div {
    flex: 1 1 0;
    width: 100%;
    min-width: 0;
  }

  form {
    width: 100%;
    max-width: 595px;

    ${media.extraLarge`
      margin-left: auto;
    `};
  }
`;

const Outro = ({ newsletter }) => (
  <React.Fragment>
    <Poster aria-hidden="true">
      <div>
        <span style={{ '--fill-start': '14%' }}>Made</span>
        <span style={{ '--fill-start': '15%' }}>For</span>
      </div>
      <div>
        <span style={{ '--fill-start': '19%' }}>Classical</span>
      </div>
    </Poster>
    {newsletter && (
      <Newsletter>
        <h2>
          <FormattedMessage
            id="footer.newsletter.headline"
            defaultMessage="Sign up for latest releases and {br}curated playlists."
            values={{ br: <br /> }}
          />
        </h2>
        <div>
          <EmailSignupForm onDark={false} from="Footer" />
        </div>
      </Newsletter>
    )}
  </React.Fragment>
);

Outro.propTypes = {
  newsletter: PropTypes.bool,
};

Outro.defaultProps = {
  newsletter: true,
};

export default Outro;



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/home/Outro.js